export default {
  title: 'Yükleme',
  price: 'Fiyat {{price}}',
  limit: 'Sınırlı <span>{{time}}</span> teklif {{doniaNo}} için lütfen en kısa sürede ödeyin',
  rate: '$1 = <span>{{coins}}coin</span>',
  totalCoins: 'Toplam coin: <span>{{coins}}</span>',
  bonus: 'Bonus',
  discountOff: '%{{percent}} OFF',
  invalidLink: 'Geçersiz yükleme bağlantısı',
  loadFailed: 'Yükleme bilgileri alınamadı',
};
